import { EventEmitter } from "@angular/core";

export abstract class Overview {
    constructor(){}
    isOverviewActive: boolean = false;

    overviewToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

    toggle() {
        this.isOverviewActive = !this.isOverviewActive;
        this.overviewToggle.emit(this.isOverviewActive);
    }

    close() {
        this.isOverviewActive = false;
        this.overviewToggle.emit(this.isOverviewActive);
    }
}